<div class="flex flex-col">
	<div class="flex self-start flex-col w-full p-2 pb-20 gap-1.5">
		@for (item of navigationData; track item.id) {
			<div
				#expandableRef
				[activeRoute]="activeRoute()"
				(expandedMenuId)="onExpandedId($event)"
				[routerActive]="item.link"
				ultra-menu-item-expandable
				[item]="item">
				@if (item.children) {
					<div class="grid grid-cols-2 gap-2 w-full pt-2">
						@for (item of item.children; track item.id) {
							@if (item.type === 'basic') {
								<a
									(click)="lightHaptic()"
									[class]="
										item.id === 'administration.vehicles' ||
										item.id === 'operations.rental-agreements'
											? 'col-span-2'
											: ''
									"
									[routerLink]="['/admin', item.link]"
									[item]="item"
									ultra-menu-card>
								</a>
							}
						}
					</div>
				}
			</div>
		}
	</div>
</div>
